import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@teo/components';
import { Plus, PencilFilled } from '@teo/components/icons';
import AddContenModal from '../ModalLP/AddContenModal';

const TraningLink = ({
  trainingDetail,
  trainingContentLinking,
  handleChangeTraining,
}) => {
  const { t } = useTranslation();
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [typeModal, steTypeModal] = useState('');
  const [link, setLink] = useState(trainingDetail?.url || '');

  return (
    <div className="border-t p-5">
      <h4 className="mb-3 text-base">
        {t('pages.learning_path.settings.training_link')}
      </h4>
      <div className="mt-5">
        <label className="mb-1 block text-sm font-semibold text-black">
          {trainingContentLinking === 'LTI' &&
            t('pages.learning_path.settings.lti_link')}
          {trainingContentLinking === 'xAPI' &&
            t('pages.learning_path.settings.xapi_link')}
        </label>
        {link ? (
          <div className="flex items-start rounded-lg border border-grey-02 p-4">
            <a
              href="www.leercentrum.be/opleidingen/brandveiligheid101/inschrijven"
              className="break-all text-sm text-[#1173DD]"
            >
              {link}
            </a>
            <div className="ml-auto">
              <IconButton
                className="ml-2 -mt-[6px] -mr-[6px] !text-[#1E1E20C7]"
                Icon={PencilFilled}
                variant="ghost"
                size="sm"
                onClick={() => {
                  steTypeModal('trainingLink');
                  setIsOpenModal(true);
                }}
              />
            </div>
          </div>
        ) : (
          <Button
            variant="ghost"
            className="flex w-full items-center gap-2 border !border-grey-02 !p-4 !text-[#1E1E2080]"
            onClick={() => {
              steTypeModal('trainingLink');
              setIsOpenModal(true);
            }}
          >
            {t('pages.learning_path.settings.no_add_link')}
            <Plus className="ml-auto w-5 text-[#4D4D50]" />
          </Button>
        )}
      </div>
      {isOpenModal && (
        <AddContenModal
          onClose={() => setIsOpenModal(false)}
          typeModal={typeModal}
          setRegistrationLink={setLink}
          registrationLink={link}
          handleChangeTraining={handleChangeTraining}
        />
      )}
    </div>
  );
};
export default TraningLink;
